import {Navigate} from "react-router-dom";
import {selectToken} from "../../reducers/User";
import {useSelector} from "react-redux";

export default function ProtectedRoute({children}) {
    const token = useSelector(selectToken);

    if (!token) {
        return <Navigate to="/login" replace/>;
    }

    return children;
}
